<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K2EZKK/tc-custom/9781526755230.jpg?1705842406559" alt="This image is the cover for the book Guide to Tracing Your Family History Using the Census"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guide to Tracing Your Family History Using the Census
      </h1>
      <p class="bookDescription body article font2">
        <b>How to use British census records in your genealogical research—includes an appendix of key resources.</b><br/><br/>The census is an essential survey of our population, and it is a source of basic information for local and national government and for various organizations dealing with education, housing, health and transport. Providing the researcher with a fascinating insight into who we were in the past, Emma Jolly’s new handbook is a useful tool for anyone keen to discover their family history. With detailed, accessible and authoritative coverage, it is full of advice on how to explore and get the most from the records.<br/><br/>Each census from 1841 to 1911 is described in detail, and later censuses are analyzed too. The main focus is on the census in England and Wales, but censuses in Scotland, Ireland, the Channel Islands and the Isle of Man are all examined and the differences explained. Particular emphasis is placed on the rapidly expanding number of websites that offer census information, making the process of research far easier to carry out. The extensive appendix gathers together all the key resources in one place.<br/><br/>Emma Jolly’s guide is an ideal introduction and tool for anyone who is researching the life and times of an ancestor.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Jolly
      </h2>
      
      <p class="authorDescription body article">Emma Jolly is a well-known genealogist and writer, specializing in London and the British Empire. She is the author of Tracing Your British Indian Ancestors and Family History for Kids. She also contributes to history publications including Discover My Past, Family Tree magazine, Your Family Tree, Genealogists' Magazine, Your Family History and the Journal of FIBIS (the Families in British India Society).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Family History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7007563e